import { render, staticRenderFns } from "./TeamsCreateEdit.vue?vue&type=template&id=dd6612f0&scoped=true&"
import script from "./TeamsCreateEdit.vue?vue&type=script&lang=js&"
export * from "./TeamsCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeamsCreateEdit.vue?vue&type=style&index=0&id=dd6612f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6612f0",
  null
  
)

export default component.exports